export interface PreloadImageOptions {
  /**
   * Whether to catch errors from the preload request. This defaults to `true`
   * so that you don't need to wrap `preloadImage` in a `try/catch` block, but
   * can be disabled if you want to provide specific error handling logic.
   *
   * @default true
   */
  catch?: boolean;
}

/**
 * Preload an image before it's actually displayed via the `src` attribute
 *
 * @param url
 * @param options
 *
 * @returns promise for preload request
 */
const preloadImage = (
  url: string,
  { catch: catchError = true }: PreloadImageOptions = {},
) => {
  const preload = new Promise((resolve, reject) => {
    const image = new Image();

    image.onload = resolve;
    image.onerror = reject;

    image.src = url;
  });

  return catchError ? preload.catch(() => {}) : preload;
};

export { preloadImage };
